import './App.css';
import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './pages/home/Home';
import Provider from './pages/home/Provider';
import ThankyouPage from './pages/home/ThankyouPage';
import ScrollToTop from './components/ScrollToTop';


function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <ScrollToTop/>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/affiliates" element={<Provider />} />
          <Route exact path="/success" element={<ThankyouPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
